export default "__VITE_ASSET__BJwoDNx___"